import axios from "axios";
import moment from "moment";
import Cookies from "universal-cookie";
import { isLocalhost } from "../../util/helpers";

const API_URL = process.env.REACT_APP_PRIME_API_URL;
const api = axios.create({
  baseURL: `${API_URL}/apiv2`,
});

const AUTH_ENDPOINTS = ['/Auth/Login', '/Auth/verify-2fa'];

const isAuthRequest = (config) =>
  AUTH_ENDPOINTS.some((endpoint) => (config?.url || '').includes(endpoint));

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && !isAuthRequest(error.config)) {
      window.location.href = '/#/login';
    }
    return Promise.reject(error);
  }
);

export default api;

export const userService = {
  login,
  verify2FA,
  logout,
  getAllCompany,
  getCompanyProfileByCode,
  getAllDepartement,
  getUnitTrustByCode,
  getAnnualStatement,
  getAnnualStatementMonthStatus,
  getAsicDebtStatement,
  getCompanyProfileReport,
  getMembersReport,
  getMembersReportDateRange,
  getDirectorsSecretariesReport,
  getAllotementJournalReport,
  getTransferJournalReport,
  getResponsibleManagerReport,
  getPublicOfficerReport,
  getDirectorsShareholdingsReport,
  getOfficerDetailsReport,
  getShareHolderDetailsReport,
  getDocumentHistoryDocReport,
  getDocumentHistoryAsicReport,
  getAsicDocumentTracking,
  getIndividualsEntities,
  getAllIndividualsEntities,
  getAllIndividualsEntitiesWithPagination,
  getAllJointHolders,
  getJointHolders,
  getAllBeneficialOwner,
  getBeneficialOwner,
  getCompanyReport,
  getQuickCompanyProfileReport,
  getAsicCompanyDetailReport,
  isUnitTrustEmpty,
  getOrderMonitorStatement,
  getDigitalSignatureStatement,
  getAsicDebtReport,
  getElectronicLodegementService,
  getCompaniesDebtReport,
  getIndividualElectronicLodegementService,
  getCompaniesDetailList,
  getFormsHistoryReport,
  getDirectorIdReport,
  getUnitTrustUnitholdersReport,
  getUnitTrustApplicationAllotmentJournalReport,
  getUnitTrustTransferJournalReport,
  getUnitTrustUnitholdersSummaryReport,
  getAsicInvoiceReport,
  getAsicInvoiceReportLinks,
  getViewCurrentAnnualStatementReport,
  postCompanyPhoneNumber,
  postCompanyEmailID,
  postIndividualPhoneNumber,
  postIndividualEmailID,
  postForgetpasswordEmail,
  postResetPassword,
  getDiv7ALoanReport,
  getForm484Information,
  getRegdInformation,
  getIndividualEntitiesProfileReport,
  getIndividualEntitiesOffices,
  postIndividualEntitiesDid,
  getIndividualEntitiesShares,
  postCompanyNotes,
  getAllCountries,
  postSignup,
  getUnitTrustTable,
  getLoggedUserInfo,
  postChangeOrderRequest,
  getClassList,
  getCompanyListReport,
  postRecentCompanyList,
  getRecentCompanyList,
  getEbinderPrimeFiles,
  getManageEbinderList,
  getEbinderLink,
  getEbinderCustomFileList,
  postEbinderCustomFileDelete,
  postEbinderCustomFileAdd,
  getEbinderCompanyList,
  postCreateEbinder,
  postToggleMFA,
  generateMFAQR,
  postChangePassword,
  getBusinessNameDetailList,
  getBusinessWelcomeReport,
  getBusinessCertificateReport,
  getBusinessNameSummary,
  getBusinessNameReport,
  postBusinessNotes,
  getBusinessNotes,
  getDirectorIdCount,
  getEdgeCompanyProfileReport,
  getCompanyEmailLogsAsync,
  getCompanyOtherDocuments,
  postCompanyOtherDocuments,
  deleteCompanyOtherDocuments,
  downloadCompanyOtherDocuments,
  getCompanySignedDocuments,
  downloadCompanySignedDocuments,
  getCompanyHierarchy,
  getDocumentTimeline,
};


export let unitTrustRecord = 0;
/*async function login(clientId, userName, password) {
  let encrypt = `${clientId}:${userName}:${password}`;
  const params = JSON.stringify({ clientId, userName });
  */

const cookies = new Cookies();

const isAppOnLocalhost = isLocalhost()
  ? ".localhost.com"
  : process.env.REACT_APP_DOMAIN;

const cookieOptions = {
  domain: isAppOnLocalhost,
  path: "/",
};

export const LOGIN_STATUS = {
  Authorized: 'Authorized',
  RequiresTwoFactor: 'RequiresTwoFactor',
};

async function login(userName, password) {
  return await api
    .post(`/Auth/Login`, {
      userName,
      password
    })
    .then((response) => {
      if (response.data === LOGIN_STATUS.Authorized) {
        localStorage.setItem("token", response.headers.token);
        localStorage.setItem("userName", userName);
        
        cookies.set("token", response.headers.token, cookieOptions);
        
        cookies.set("userName", userName, cookieOptions);
        cookies.set("password", password, cookieOptions);
      }


      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function verify2FA(UserName, ValidationToken, MfaCode) {
  return await api
    .post(`/Auth/verify-2fa`, {
      UserName,
      ValidationToken,
      MfaCode,
    })
    .then((response) => {
      if (response.data === LOGIN_STATUS.Authorized) {
        localStorage.setItem("token", response.headers.token);
        localStorage.setItem("userName", UserName);
        
        cookies.set("token", response.headers.token, cookieOptions);
        cookies.set("userName", UserName, cookieOptions);
      }

      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("token");
  localStorage.removeItem("password");
  localStorage.removeItem("userName");
  localStorage.removeItem("inputSearchValue");
  localStorage.removeItem("selectedSearchValue");
  localStorage.removeItem("companyName");
  localStorage.removeItem("companyCode");
  localStorage.removeItem("recentCompanySearch");

  cookies.remove("token", cookieOptions);
  cookies.remove("userName", cookieOptions);
  cookies.remove("password", cookieOptions);
  cookies.remove("fullName", cookieOptions);
  cookies.remove("roleId", cookieOptions);
  cookies.remove("greenId", cookieOptions);
}

async function getAllCompany(token) {
  console.log("token:::::::::::::::::::::::", token);
  return await api
    .get(`/RegCompany/GetCompanies?department=@all`, {
      headers: {
        token: token ? token : localStorage.getItem("token"),
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      localStorage.removeItem("inputSearchValue");
      localStorage.removeItem("selectedSearchValue");
      localStorage.removeItem("companyName");
      localStorage.removeItem("companyCode");
      localStorage.removeItem("recentCompanySearch");
    });
}
async function getCompanyProfileByCode(code) {
  return await api
    .get(
      `/RegCompany/GetCompanyDetail/${encodeURIComponent(code)}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      localStorage.removeItem("inputSearchValue");
      localStorage.removeItem("selectedSearchValue");
      localStorage.removeItem("companyName");
      localStorage.removeItem("companyCode");
      localStorage.removeItem("recentCompanySearch");
      return Promise.reject(error);
    });
}

async function getAllDepartement() {
  return await api
    .get(`/APIUser/GetDepartmentList`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data !== "No Department Found!" ? response.data : "";
    })
    .catch((error) => {
      // console.warn(error.response, "error");
      // if (error.response.status === 401) {
      //   logout();
      // }
      return Promise.reject(error);
    });
}
async function getUnitTrustByCode(companyCode, mode) {
  return await api
    .get(
      `/RegCompany/GetUnitTrust/${encodeURIComponent(companyCode)}/${mode}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      unitTrustRecord =
        response.data !== "No Unit Trust Found." ? response.data.length : "";
      return response.data !== "No Unit Trust Found." ? response.data : "";
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getAnnualStatement(currentYear, selectedMonth) {
  return await api
    .get(
      `/AnnualStatement/GetAnnualStatementMonthList_New/${currentYear}/${selectedMonth}`,
      //existing API accepts boolean value of current, previous year
      // `/AnnualStatement/GetAnnualStatementMonthList/${currentYear}/${selectedMonth}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data.CompanyList;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAnnualStatementMonthStatus(currentYear) {
  return await api
    .get(
      `/AnnualStatement/GetMonthlyStatus_New/${currentYear}`,
      {
        //existing API  bellow accepts boolean value of current, previous year
        //`/AnnualStatement/GetMonthlyStatus/${currentYear}`, {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAsicDebtStatement() {
  return await api
    .get(`/CompanyDebt/GetCompanyDebtList`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getCompanyProfileReport() {
  return await api
    .get(
      `/PrimeReports/ShowReport/QuickRegistryCompanyProfile/1APRIMEPROPRI01`,
      {
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      //window.open(response.data)
      return fileURL;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getMembersReport(members, companyCode) {
  const summaryReport = members.summaryReport === 'Yes' ? "Yes/xls" : members.summaryReport;
  const downloadXls = members.summaryReport === 'Yes'
  
  const memberReportParams = `As At Date=${moment(members.printDate).format(
    "DD-MM-YY"
  )},Show Beneficial Owner Name=${
    members.benificialName
  },Show Holding Summmary OnlyQQQ=${
    members.holdingSummary
  },Show Zero BalancesQQQ=${members.zeroBalance},Show Address FieldsQQQ=${
    members.address
  },Show Foreign Currency (if any)QQQ=${
    members.foreignCurrency
  },Show Total Shares=${
    members.totalShares
  }, Include Options=${
    members.includeOptions
  }, Show Summary Report=${summaryReport}`;


  return await api
    .get(
      `/PrimeReports/ShowReport/corpregMembers/${companyCode}/${memberReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      if (downloadXls) {
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a')
        a.href = url
        a.download = ''
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(url)
        a.remove()
      } else {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getMembersReportDateRange(members, companyCode) {
  //https://testserver.primecloud.com.au/apiv2/PrimeReports/ShowReport/corpregMembersDateRange/181CAPITALPTY01/From Date=01-05-2023,As At Date=30-05-2023,Show Beneficial Owner Name=Yes,Show Holding Summmary OnlyQQQ=No,Show Zero BalancesQQQ=Yes,Show Address FieldsQQQ=Yes,Show Foreign Currency (if any)QQQ=No,Show Total Shares=No

  const memberReportParams = `From Date=${moment(members.fromDate).format("DD-MM-YY")}
  ,As At Date=${moment(members.toDate).format("DD-MM-YY")}
  ,Show Beneficial Owner Name=${
    members.benificialName
  },Show Holding Summmary OnlyQQQ=${
    members.holdingSummary
  },Show Zero BalancesQQQ=${members.zeroBalance},Show Address FieldsQQQ=${
    members.address
  },Show Foreign Currency (if any)QQQ=${
    members.foreignCurrency
  },Show Total Shares=${
    members.totalShares
  }, Include Options=${members.includeOptions}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/corpregMembersDateRange/${companyCode}/${memberReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getDirectorsSecretariesReport(officers, companyCode) {
  const directorsSecretariesReportParams = `As At Date=${moment(
    officers.dsPrintDate
  ).format("DD-MM-YYYY")},Current Officers=${officers.officer}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/directorsNsecretarie/${companyCode}/${directorsSecretariesReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAllotementJournalReport(allotmentJournal, companyCode) {
  const allotmentJournalReportParams = `As At Date=${moment(
    allotmentJournal.ajPrintDate
  ).format("DD-MM-YYYY")}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/allotmentJournal/${companyCode}/${allotmentJournalReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getTransferJournalReport(transferJournal, companyCode) {
  const transferJournalReportParams = `As At Date=${moment(
    transferJournal.tjPrintDate
  ).format("DD-MM-YYYY")}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/transferJournal/${companyCode}/${transferJournalReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getResponsibleManagerReport(responsibleManager, companyCode) {
  const responsibleManagerReportParams = `As At Date=${moment(
    responsibleManager.rmPrintDate
  ).format("DD-MM-YYYY")},Current Officers=${responsibleManager.rofficer}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/responsibleManager/${companyCode}/${responsibleManagerReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getPublicOfficerReport(publicOfficers, companyCode) {
  const PublicOfficerReportParams = `As At Date=${moment(
    publicOfficers.poPrintDate
  ).format("DD-MM-YYYY")},Current Officers=${publicOfficers.publicOfficer}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/publicOfficer/${companyCode}/${PublicOfficerReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getDirectorsShareholdingsReport(
  directorshareholdings,
  companyCode
) {
  const DirectorsShareholdingsReportParams = `As At Date=${moment(
    directorshareholdings.dsprintDate
  ).format("DD-MM-YYYY")}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/directorShareholding/${companyCode}/${DirectorsShareholdingsReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getOfficerDetailsReport(officerCode) {
  return await api
    .get(
      `/RegCompany/GetShapShotOfficersDetail/${officerCode}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getShareHolderDetailsReport(code, holderType) {
  return await api
    .get(
      `/RegCompany/GetShapShotShareholdersDetail/${code}/${holderType}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getDocumentHistoryDocReport(RN, formNo, docNo) {
  return await api
    .get(
      `/PrimeReports/GetDocumentPackage//${RN}/${formNo}/${docNo}`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((errorDocumentHistory) => {
      return Promise.reject(errorDocumentHistory);
    });
}
async function getDocumentHistoryAsicReport(asicDocNo) {
  return await api
    .get(`/PrimeReports/ShowReport/${asicDocNo}`, {
      responseType: "arraybuffer",
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((errorAsicDocumentHistory) => {
      return Promise.reject(errorAsicDocumentHistory);
    });
}
async function getAsicDocumentTracking(code) {
  return await api
    .get(
      `/Document/GetDocumentTracking/${encodeURIComponent(code)}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAllIndividualsEntities() {
  return getIndividualsEntities("all");
}

async function getIndividualsEntities(companyCode) {
  return await api
    .get(
      `/IndividualEntities/GetIndividualEntitiesList/${companyCode}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAllIndividualsEntitiesWithPagination(
  search,
  sortBy,
  sortOrder,
  countPerPage,
  pageNo
) {
  const individualEntitiesParams = `search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}&countPerPage=${countPerPage}&pageNo=${pageNo}`;
  return await api
    .get(
      `/IndividualEntities/GetIndividualEntities?${individualEntitiesParams}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getAllJointHolders() {
  return getJointHolders("all");
}

async function getJointHolders(code) {
  return await api
    .get(`/JointHolders/GetJointHoldersList/${code}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAllBeneficialOwner() {
  return getBeneficialOwner("all");
}

async function getBeneficialOwner(code) {
  return await api
    .get(`/Benficialowner/GetBenficialOwnerList/${code}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getCompanyReport(printCompany, companyCode) {
  const asAtDate = moment(printCompany.asDate, "DD/MM/yyyy").format(
    "DD-MM-yyyy"
  );
  const companyReportParams = `ShowDocumentsLodged List=${printCompany.docLodge},ShowCurrentOfficeholdersOnly=${printCompany.officeHolders},AsAtDate=${asAtDate}`;
  const apiURL = `/PrimeReports/ShowReport/RegistryCompanyProfile/${companyCode}/${companyReportParams}`;

  return await api
    .get(`${apiURL}`, {
      responseType: "arraybuffer",
      headers: {
        token: localStorage.getItem("token"),
        "Content-Type": "application/pdf",
      },
    })
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      //console.log(`window.open('${fileURL}')`);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getQuickCompanyProfileReport(companyCode) {
  return await api
    .get(
      `/PrimeReports/ShowReport/QuickRegistryCompanyProfile/${companyCode}/Show Current Officeholders Only=Yes,Show Documents Lodged List=No/`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAsicCompanyDetailReport(asicCompanyDetail, companyCode) {
  const asicCompanyReportParams = `ShowGivenNameFields=${asicCompanyDetail.nameField}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/eSearchCompanyExtract/${companyCode}/${asicCompanyReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

function isUnitTrustEmpty() {
  return unitTrustRecord;
}

async function getOrderMonitorStatement() {
  return await api
    .get(`/Orders/GetOrdersList`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getDigitalSignatureStatement() {
  return await api
    .get(`/Docusign/GetDocusignList`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAsicDebtReport(ACN) {
  return await api
    .get(
      `/PrimeReports/ShowReport/EDGEIndividualCompanyDebtReport/${ACN}/none`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getElectronicLodegementService() {
  return await api
    .get(`/ELSBatch/GetElsBatchList`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getCompaniesDebtReport(details) {
  const companiesDebtReportParams = `Show Zero BalancesQQQ=${details.zeroBalance},Show CreditBalance=${details.creditBalance},Show Alphabetical Order=${details.sortReport}`;
  return await api
    .get(
      `/PrimeReports/ShowReport/EDGECompanyDebtReport/all//${companiesDebtReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getIndividualElectronicLodegementService(companyCode) {
  return await api
    .get(`/ELSBatch/GetCompanyElsBatchList/${companyCode}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getCompaniesDetailList() {
  return await api
    .get(`/RegCompany/GetCompaniesDetailList`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getFormsHistoryReport(Code) {
  return await api
    .get(
      `/PrimeReports/ShowReport/printDocumentHistory/${Code}/none`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getDirectorIdReport(didList, typedoc) {
  const didListReportParams = `${didList.didType}`;
  return await api
    .get(
      `/PrimeReports/ShowReport/viewDirectorIDList/${didListReportParams}/none/${typedoc}`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], {
        type:
          typedoc === "pdf" ? "application/pdf" : " application/vnd.ms-excel",
      });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getAsicInvoiceReport(companyCode, companyName) {
  return await api
    .get(
      `/AnnualStatement/GetAnnualStatementInvoice/${companyCode}/${companyName}`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((errorAsicInvoiceReport) => {
      return Promise.reject(errorAsicInvoiceReport);
    });
}
async function getAsicInvoiceReportLinks(companyCode) {
  return await api
    .get(`/CompanyDebt/GetLatestFiveInvoices/${companyCode}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((errorAsicInvoiceReportLink) => {
      return Promise.reject(errorAsicInvoiceReportLink);
    });
}

async function getViewCurrentAnnualStatementReport(companyCode, companyName) {
  return await api
    .get(
      `/AnnualStatement/GetAnnualStatementPackage/${companyCode}/${companyName}`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((errorViewCurrentAnnualStatement) => {
      return Promise.reject(errorViewCurrentAnnualStatement);
    });
}

async function getUnitTrustUnitholdersReport(unitTrustRN) {
  return await api
    .get(
      `/PrimeReports/ShowReport/unitholdersRegister/${unitTrustRN}/none`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getUnitTrustApplicationAllotmentJournalReport(unitTrustRN) {
  return await api
    .get(
      `/PrimeReports/ShowReport/unitApplicationandAllotmentJournal/${unitTrustRN}/none`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getUnitTrustTransferJournalReport(unitTrustRN) {
  return await api
    .get(
      `/PrimeReports/ShowReport/unitsTransferJournal/${unitTrustRN}/none`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getUnitTrustUnitholdersSummaryReport(unitTrustRN) {
  return await api
    .get(
      `/PrimeReports/ShowReport/unitholdersSummary/${unitTrustRN}/none`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postCompanyPhoneNumber(RN, mobileNumber) {
  const params = "";
  return await api
    .post(
      `/RegCompany/UpdateTelephoneNumber/${RN}/C/${mobileNumber}`,
      params,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postCompanyEmailID(RN, emailId) {
  const params = "";
  return await api
    .post(
      `/RegCompany/UpdateEmailAddress/${RN}/C/${emailId}/`,
      params,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postIndividualPhoneNumber(RN, mobileNumber) {
  const params = "";
  return await api
    .post(
      `/RegCompany/UpdateTelephoneNumber/${RN}/I/${mobileNumber}`,
      params,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postIndividualEmailID(RN, emailId, detail) {
  const params = "";
  console.log("companyor individual", detail);
  const detailParam = detail ? detail : "I";
  console.log("companyor individual", detailParam);
  return await api
    .post(
      `/RegCompany/UpdateEmailAddress/${RN}/${detailParam}/${emailId}/`,
      params,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postForgetpasswordEmail(userName) {
  const params = "";
  return await api
    .post(
      `/Auth/ForgotPassword?username=${userName}`,
      params,
      {}
    )
    .then((response) => {
      return response.data;
    })
    .catch((errorForgetPasswordEmail) => {
      return Promise.reject(errorForgetPasswordEmail);
    });
}

async function postResetPassword(userName, passWord, confirmPassword, rCode) {
  return await api
    .post(`/Auth/ResetPassword`, {
      UserID: userName,
      Password: passWord,
      ConfirmPassword: confirmPassword,
      Code: rCode,
    })
    .then((response) => {
      return response.data;
    })
    .catch((errorResetPassword) => {
      return Promise.reject(errorResetPassword);
    });
}

async function getDiv7ALoanReport(companyCode, reportParam) {
  console.log("reportParam", reportParam);
  const param = {
    responseType: "arraybuffer",
    headers: { token: localStorage.getItem("token") },
  };
  const address =
    reportParam.associateAddress &&
    reportParam.associateAddress.replace(/,/g, "{comma}");
  const state = reportParam.stateLocation;
  return await api
    .get(
      `/PrimeReports/ShowReport/Div_7A_Loan_Agreement_PORTAL/${companyCode}/Enter Loan Balance (or leave Bank)=${reportParam.loanBalance},Associate Name=${reportParam.associateName},Associate Address=${address},State of Jurisdiction=${state}/`,
      param
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getForm484Information(rN, docNo) {
  return await api
    .get(`/Document/GetDocumentSummary/${rN}/${docNo}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getRegdInformation(ACN) {
  return await api
    .get(`/RegCompany/GetCompanyASICStatus/${ACN}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((errorRegdInformation) => {
      return Promise.reject(errorRegdInformation);
    });
}

async function getIndividualEntitiesProfileReport(code) {
  return await api
    .get(
      `/PrimeReports/ShowReport/IndividualandEntitiesProfile/${code}/Current Officers and Shareholders=Yes,Show Other Public Co. Directorships (if entered)=Yes/`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getIndividualEntitiesOffices(code) {
  return await api
    .get(`/IndividualEntities/GetOfficerCompany/${code}/`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getIndividualEntitiesShares(code) {
  return await api
    .get(`/IndividualEntities/GetShareholderCompany/${code}/`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postIndividualEntitiesDid(RN, did) {
  const params = "";
  const emptyDid = did && did.replace(/_/g, "");
  return await api
    .post(
      `/IndividualEntities/UpdateDID/${RN}/${emptyDid}`,
      params,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((errorDidUpdate) => {
      return Promise.reject(errorDidUpdate);
    });
}
async function postCompanyNotes(RN, notes) {
  return await api
    .post(
      `/RegCompany/SetCompanyNotes`,
      { identifier: RN, notes: notes },
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getAllCountries() {
  return await api
    .get(`https://restcountries.com/v3.1/all`)
    .then((response) => {
      return response.data ? response.data.map((value) => value.name) : "";
    })
    .catch((errorCountries) => {
      return Promise.reject(errorCountries);
    });
}
async function postSignup(firstName, lastName, phone, email, organisationName) {
  return await api
    .post(`/Auth/Register`, {
      FirstName: firstName,
      LastName: lastName,
      phone: phone,
      Email: email,
      OrganisationName: organisationName,
    })
    .then((response) => {
      return response.data;
    })
    .catch((errorSignup) => {
      return Promise.reject(errorSignup);
    });
}
async function getUnitTrustTable(departement) {
  return await api
    .get(`/RegCompany/GetUnitRegisterList/${departement}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((unitTrustTableError) => {
      return Promise.reject(unitTrustTableError);
    });
}

async function getLoggedUserInfo() {
  return await axios
    .get(`${API_URL}/apiv2/APIUser/GetUserInfo`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      console.warn(response.data);
      cookies.set("fullName", response.data.FullName, cookieOptions);
      cookies.set("roleId", response.data.IDRole, cookieOptions);
      if (response.data.GreenId) {
        cookies.set('greenId', response.data.GreenId, cookieOptions);
      }
      return response.data;
    })
    .catch((loggedUserInfoError) => {
      return Promise.reject(loggedUserInfoError);
    });
}

async function postChangeOrderRequest(changeOrder) {
  return await api
    .post(
      `/Orders/PostOnlineOrder`,
      {
        data: changeOrder,
      },
      {
        headers: {
          token: localStorage.getItem("token"),
          contentType: "multipart/form-data",
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((changeOrderError) => {
      return Promise.reject(changeOrderError);
    });
}

async function getClassList(code) {
  return await api
    .get(`/RegCompany/GetAllAssociatedClass/${code}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((classlistError) => {
      return Promise.reject(classlistError);
    });
}
async function getCompanyListReport(companyCode, companyList) {
  const companyListReportParams = `AgentID=${companyList.dept},Show Email Addresses=${companyList.email},Show Officers{slash}MembersQQQ=${companyList.officer}`;

  return await api
    .get(
      `/PrimeReports/ShowReport/CompanyEmailList/${companyCode}/${companyListReportParams}`,
      {
        responseType: "arraybuffer",
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "application/pdf",
        },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postRecentCompanyList(userName, clientId, deptCode, ACN) {
  const params = {
    USER_ID: userName,
    CLIENT_ID: clientId,
    DEPT_CODE: deptCode,
    CO_ACN: ACN,
  };
  return await api
    .post(`/RegCompany/PostRecentComanyHistory`, params, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((errorPostRecentCompanyList) => {
      return Promise.reject(errorPostRecentCompanyList);
    });
}

async function getRecentCompanyList(userName, clientId, deptCode) {
  return await api
    .get(
      `/RegCompany/GetRecentComanyHistory/${clientId}/${userName}/${deptCode}/`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data !== "No Recent Search Found!" ? response.data : "";
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getEbinderPrimeFiles(Code) {
  return await api
    .get(`/portal/ebinders/company/${Code}/primefiles`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getManageEbinderList(Code) {
  const params = { companyCode: Code };
  console.log("params", params);
  return await api
    .get(
      `/portal/ebinders/company/binder-list?companycode=${Code}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getEbinderLink(Code, binderId) {
  return await api
    .get(
      `/portal/ebinders/company/binder?companycode=${Code}&binderId=${binderId}`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getEbinderCustomFileList(Code) {
  return await api
    .get(`/portal/ebinders/company/${Code}/customfiles`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postEbinderCustomFileDelete(Code, fileName) {
  return await api
    .post(
      `/portal/ebinders/company/${Code}/customfiles/delete`,
      { identifier: Code, filename: fileName },
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postEbinderCustomFileAdd(Code, formdata) {
  return await api
    .post(
      `/portal/ebinders/company/${Code}/customfiles`,
      formdata,
      {
        headers: { token: localStorage.getItem("token") },
        "Content-Type": "multipart/form-data",
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getEbinderCompanyList() {
  return await api
    .get(`/portal/ebinders/company?department=@all`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postCreateEbinder(
  Code,
  selectedPrimeFileList,
  companyRegister,
  customFileList
) {
  return await api
    .post(
      `/portal/ebinders/company/${Code}/create`,
      {
        registers: companyRegister,
        primeForms: selectedPrimeFileList,
        customFiles: customFileList,
      },
      {
        headers: {
          token: localStorage.getItem("token"),
          contentType: "multipart/form-data",
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postToggleMFA(clientId, userId, IsMFAEnable, MFAType) {
  return await api
  .post(`/APIUser/UpdateMFASetting`, {
    clientId,
    userId,
    IsMFAEnable,
    MFAType,
  }, {
    headers: { token: localStorage.getItem("token") },
  })
  .then((response) => response.data)
  .catch((error) => Promise.reject(error));
}

async function generateMFAQR() {
  return await api
    .get(`/Auth/generate-qr`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

async function postChangePassword(
  clientId,
  userId,
  oldPassword,
  passWord,
  confirmPassword
) {
  const params = {
    ClientID: clientId,
    UserID: userId,
    OldPassword: oldPassword,
    Password: passWord,
    ConfirmPassword: confirmPassword,
  };
  return await api
    .post(`/APIUser/UpdatePassword`, params, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((errorChangePassword) => {
      return Promise.reject(errorChangePassword);
    });
}
async function getBusinessNameDetailList() {
  return await api
    .get(
      `/portal/businessName/businessNameTable?department=@all`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getBusinessWelcomeReport(reportParam) {
  console.log("reportParam business ID", reportParam);
  const param = {
    responseType: "arraybuffer",
    headers: { token: localStorage.getItem("token") },
  };

  return await api
    .get(
      `/portal/businessName/welcomeletter?businessID=${reportParam}`,
      param
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getBusinessCertificateReport(reportParam) {
  console.log("reportParam businessCertificate ID", reportParam);
  const param = {
    responseType: "arraybuffer",
    headers: { token: localStorage.getItem("token") },
  };

  return await api
    .get(
      `/portal/businessName/businessCertificate?businessID=${reportParam}`,
      param
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getBusinessNameSummary(reportParam) {
  console.log("reportParam businessCertificate ID", reportParam);
  const param = {
    headers: { token: localStorage.getItem("token") },
  };
  return await api
    .get(
      `/portal/businessName/businessName?department=@all&rn=${reportParam}`,
      param
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getBusinessNameReport(reportParam) {
  console.log("reportParam business ID", reportParam);
  const param = {
    responseType: "arraybuffer",
    headers: { token: localStorage.getItem("token") },
  };

  return await api
    .get(
      `/PrimeReports/ShowReportParam/BusinessNameReport/${reportParam}`,
      param
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postBusinessNotes(identifier, notes) {
  return await api
    .post(
      `/portal/BusinessName/BusinessNameNotes/`,
      { identifier: identifier, notes: notes },
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
async function getBusinessNotes(identifier) {
  return await api
    .get(
      `/portal/BusinessName/BusinessNameNotes/${identifier}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getDirectorIdCount() {
  return await api
    .get(`/IndividualEntities/GetDIDCount`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getEdgeCompanyProfileReport(companyCode) {
  return await api
    .get(
      `/PrimeReports/ShowReport/EdgeCompanyProfile/${companyCode}/none/pdf`,
      {
        responseType: "arraybuffer",
        headers: { token: localStorage.getItem("token") },
      }
    )
    .then((response) => {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getCompanyEmailLogsAsync(companyCode) {
  return await api
    .get(`/PrimeEmail/GetCompanyEmailLogsAsync?acn=${companyCode}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getCompanyOtherDocuments(companyCode) {
  return await api
    .get(`/CompanyDocuments/GetCompanyDocuments?acn=${companyCode}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function postCompanyOtherDocuments(companyCode, formData) {
  return await api
    .post(`/CompanyDocuments/UploadCompanyDocuments?acn=${companyCode}`, formData, {
      headers: {
        token: localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function deleteCompanyOtherDocuments(companyCode, fileName) {
  const encodedFileName = encodeURIComponent(fileName)
  return await api
    .post(`/CompanyDocuments/DeleteCompanyDocuments?acn=${companyCode}&fileName=${encodedFileName}`, null, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function downloadCompanyOtherDocuments(companyCode, fileName) {
  try {
    const encodedFileName = encodeURIComponent(fileName)
    const response = await api.get(
      `/CompanyDocuments/DownloadCompanyDocuments?acn=${companyCode}&fileName=${encodedFileName}`,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      }
    )

    const disposition = response.headers?.["content-disposition"] || ""
    let inferredName = fileName
    const utf8Match = /filename\*\=UTF-8''([^;]+)/i.exec(disposition)
    const asciiMatch = /filename="?([^"]+)"?/i.exec(disposition)
    if (utf8Match?.[1]) inferredName = decodeURIComponent(utf8Match[1])
    else if (asciiMatch?.[1]) inferredName = asciiMatch[1]

    const mimeType = response.headers?.["content-type"] || "application/octet-stream"
    const blob = new Blob([response.data], { type: mimeType })
    const url = URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = url
    a.download = inferredName || "download"
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)

    return true
  } catch (error) {
    return Promise.reject(error)
  }
}

async function getCompanySignedDocuments(companyCode) {
  return await api
    .get(`/CompanyDocuments/Signed/GetCompanyDocuments?acn=${companyCode}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function downloadCompanySignedDocuments(companyCode, fileName) {
  try {
    const encodedFileName = encodeURIComponent(fileName)
    const response = await api.get(
      `/CompanyDocuments/Signed/DownloadCompanyDocuments?acn=${companyCode}&fileName=${encodedFileName}`,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      }
    )

    const disposition = response.headers?.["content-disposition"] || ""
    let inferredName = fileName
    const utf8Match = /filename\*\=UTF-8''([^;]+)/i.exec(disposition)
    const asciiMatch = /filename="?([^"]+)"?/i.exec(disposition)
    if (utf8Match?.[1]) inferredName = decodeURIComponent(utf8Match[1])
    else if (asciiMatch?.[1]) inferredName = asciiMatch[1]

    const mimeType = response.headers?.["content-type"] || "application/octet-stream"
    const blob = new Blob([response.data], { type: mimeType })
    const url = URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = url
    a.download = inferredName || "download"
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)

    return true
  } catch (error) {
    return Promise.reject(error)
  }
}

async function getCompanyHierarchy(acn) {
  const cleanAcn = acn.replace(/\s/g, '');
  return await api
    .get(`/RegCompany/Hierarchy-json?acn=${cleanAcn}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}

async function getDocumentTimeline(coCode, showCreatedBy = false) {
  return await api
    .get(`/Document/GetDocumentTimelineJson?coCode=${coCode}&ShowCreatedBy=${showCreatedBy}`, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
}
